import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { getBrandName } from 'utils/helpers';
import LoadingButton from 'components/loading_button/loading_button';
import { discardBooking } from 'redux/actions/booking';
import { setBookingTenant } from 'redux/actions/ui/sealink';

const ActionButtons = ({
  type,
  bookingTenant,
  loginTenant,
  setShow,
  destination,
}) => {
  const dispatch = useDispatch();
  const [isRemoving, setIsRemoving] = useState(false);
  const apiPrefix = ecom.craftConfig.api_prefix;
  const removeBooking = ({ redirect = false } = {}) => {
    setIsRemoving(true);
    dispatch(discardBooking()).then(() => {
      setShow(false);
      setIsRemoving(false);
      dispatch(setBookingTenant(null));

      if (redirect) {
        window.location.assign(destination);
      }
    });
  };
  const logout = () => {
    setIsRemoving(true);

    let url = `${apiPrefix}/account/logout?redirect=${destination}`;

    // On the national homepage, the apiPrefix is null
    if (apiPrefix === null) {
      url = '/account/logout?redirect=/';
    }

    window.location.assign(url);
  };
  const backToLoginTenant = () =>
    window.location.assign(`${loginTenant.site_url}`);

  switch (type) {
    case 'hasBookingAndOnAnotherTenant':
      return (
        <>
          <Button
            variant="outline-primary"
            onClick={() =>
              window.location.assign(`${bookingTenant.site_url}/bookings`)
            }
          >
            Back to my booking
          </Button>
          <LoadingButton
            loading={isRemoving}
            onClick={() => removeBooking()}
            className="btn btn-primary"
          >
            Remove booking and stay here
          </LoadingButton>
        </>
      );
    case 'hasBookingAndSwitch':
      return (
        <>
          <Button variant="outline-primary" onClick={() => setShow(false)}>
            Close and stay here
          </Button>
          <LoadingButton
            loading={isRemoving}
            onClick={() => removeBooking({ redirect: true })}
            className="btn btn-primary"
          >
            Remove booking and proceed
          </LoadingButton>
        </>
      );
    case 'hasLoggedInAndOnAnotherTenant':
      return (
        <>
          <Button variant="outline-primary" onClick={backToLoginTenant}>
            {`Return to ${getBrandName()} `}
            {loginTenant.site_name}
          </Button>
          <LoadingButton
            loading={isRemoving}
            onClick={logout}
            className="btn btn-primary"
          >
            Logout and continue
          </LoadingButton>
        </>
      );
    case 'hasLoggedInWithBookingAndOnAnotherTenant':
      return (
        <>
          <Button onClick={backToLoginTenant} variant="outline-primary">
            {`Return to ${getBrandName()} `}
            {loginTenant.site_name}
          </Button>
          <LoadingButton
            loading={isRemoving}
            onClick={logout}
            className="btn btn-primary"
          >
            Logout, clear booking and continue
          </LoadingButton>
        </>
      );
    case 'hasLoggedInAndSwitch':
      return (
        <>
          <Button onClick={() => setShow(false)} variant="outline-primary">
            Close and stay here
          </Button>
          <LoadingButton
            loading={isRemoving}
            onClick={logout}
            className="btn btn-primary"
          >
            Logout and continue
          </LoadingButton>
        </>
      );
    case 'hasLoggedInWithBookingAndSwitch':
      return (
        <>
          <Button onClick={() => setShow(false)} variant="outline-primary">
            Close and stay here
          </Button>
          <LoadingButton
            loading={isRemoving}
            onClick={logout}
            className="btn btn-primary"
          >
            Logout, clear booking and continue
          </LoadingButton>
        </>
      );
    default:
      return null;
  }
};

const tenantShape = PropTypes.shape({
  site_name: PropTypes.string,
  site_url: PropTypes.string,
});

ActionButtons.propTypes = {
  type: PropTypes.string,
  bookingTenant: tenantShape,
  loginTenant: tenantShape,
  setShow: PropTypes.func,
  destination: PropTypes.string,
};

export default ActionButtons;
